import uuid from "react-native-uuid";
import { EditorState } from "draft-js";
import HTMLtoDraft from "../../utils/HTMLtoDraft/HTMLtoDraft";
import { GOOGLE_SHEET_VIEW_CONTROL } from "../../constants";
import { USER_ROLES } from "../../constants/roleList";

const createRow = (index, firstRowAsHeader) => {
  const row = {
    attributes: {
      columnCount: 0,
      id: uuid.v4(),
    },
    data: [],
  };
  if (index === 0 && firstRowAsHeader) {
    row.attributes.header = true;
  }
  return row;
};

const objHas = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

const addStyling = cell => {
  let htmlString = cell.formattedValue;
  let styleString = "";
  if (objHas(cell, "effectiveFormat")) {
    const { effectiveFormat } = cell;
    if (objHas(effectiveFormat, "textFormat")) {
      if (
        objHas(effectiveFormat.textFormat, "bold") &&
        effectiveFormat.textFormat.bold === true
      ) {
        // styleString += "font-weight:bold;";
        htmlString = `<strong>${htmlString}</strong>`;
      }
      if (
        objHas(effectiveFormat.textFormat, "italic") &&
        effectiveFormat.textFormat.italic === true
      ) {
        // styleString += "font-style:italic;";
        htmlString = `<em>${htmlString}</em>`;
      }
      if (
        objHas(effectiveFormat.textFormat, "underline") &&
        effectiveFormat.textFormat.underline === true
      ) {
        // styleString += "text-decoration:underline;";
        htmlString = `<u>${htmlString}</u>`;
      }
      if (objHas(effectiveFormat.textFormat, "fontSize")) {
        styleString += `font-size:${effectiveFormat.textFormat.fontSize}pt;`;
      }
    }
  }

  if (styleString.length > 0) {
    htmlString = `<p style="${styleString}">${htmlString}</p>`;
  }
  return htmlString;
};

const createCellData = cell => {
  if (cell && objHas(cell, "formattedValue")) {
    const htmlString = addStyling(cell);
    const draftData = HTMLtoDraft(htmlString);
    const cellData = {
      data: draftData,
      editorState: EditorState.createWithContent(draftData),
    };
    return cellData;
  }
  return "";
};

const createCell = cell => ({
  attributes: {
    id: uuid.v4(),
  },
  data: cell ? createCellData(cell) : "",
});

const createBlankGSheet = firstRowAsHeader => {
  // this creates a blank 5col * 3row table
  const emptyTable = [];
  for (let i = 0; i < 3; i += 1) {
    const revvTableRow = createRow(i, firstRowAsHeader);
    for (let j = 0; j < 5; j += 1) {
      const revvTableCell = createCell();
      revvTableRow.data.push(revvTableCell);
    }
    emptyTable.push(revvTableRow);
  }
  return emptyTable;
};

const getLastColIndex = range => {
  const rangeEnd = range.split(":");
  const lastCol = rangeEnd[1].split("")[0];
  const lastColIndex = lastCol.toLocaleLowerCase().charCodeAt(0) - 97;
  return lastColIndex;
};

const fillUpRows = (rowObj, range) => {
  if (!range) {
    return rowObj;
  }
  const lastColIndex = getLastColIndex(range);
  if (rowObj && rowObj.data && rowObj.data.length <= lastColIndex) {
    const cellsToBeAdded = lastColIndex - rowObj.data.length;
    for (let i = 0; i <= cellsToBeAdded; i += 1) {
      rowObj.data.push(createCell());
    }
    return rowObj;
  }
  return rowObj;
};

export const gSheetToRevvTable = (data, firstRowAsHeader) => {
  const range = data.DataRange;
  const lastColIndex = getLastColIndex(range);
  const sheet = data.SheetData.sheets[0].data[0].rowData;
  let sheetTableData = [];
  if (sheet && sheet.length > 0) {
    sheet.forEach((row, index) => {
      if (row.values) {
        const revvTableRow = createRow(index, firstRowAsHeader);
        row.values.forEach(cell => {
          const revvTableCell = createCell(cell);
          revvTableRow.data.push(revvTableCell);
        });
        sheetTableData.push(fillUpRows(revvTableRow, range));
      } else {
        const dummyRow = createRow();
        sheetTableData.push(fillUpRows(dummyRow, range));
      }
    });
  } else {
    sheetTableData = createBlankGSheet(firstRowAsHeader);
  }
  return {
    sheetTableData,
    columnCount: lastColIndex + 1,
    originalColumnCount: lastColIndex + 1,
  };
};

export const googleSheetViewControl = (currentUser, docID) => {
  let userStatus = "";
  if (currentUser && currentUser.id === docID) {
    userStatus = GOOGLE_SHEET_VIEW_CONTROL.DOC_OWNER;
  } else if (
    currentUser &&
    currentUser.roles &&
    currentUser.roles[0].name === USER_ROLES.ADMIN
  ) {
    userStatus = GOOGLE_SHEET_VIEW_CONTROL.ACCOUNT_OWNER;
  } else {
    userStatus = GOOGLE_SHEET_VIEW_CONTROL.EXTERNAL_USER;
  }
  return userStatus;
};
